export const MAXIMUM_SELECTED_COUNT = 20001;
